const {jQuery: $} = window;
import Cookies from 'js-cookie';
import Utils from "./utils.class";
import Featherlight from "./../lib/featherlight";


export default class Theme {
    $main;
    $html;
    $body;
    $navbar;
    $hero;

    #config;
    #builder;
    #utils;

    constructor(
        config,
        builder,
        utils,
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;



        this.$html = $('html');
        this.$body = $('body');

        this.$hero = $('header.site-header');
        this.$navbar = $('.navbar-top');
    }

    __onReady() {
        const me = this;

        console.log("Theme Ready");

        // Youtube lightbox
        $('a').each(function(i, el) {
            var url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if(url) {
                if(url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || url.indexOf("youtube.com/embed/") >= 0
                    || url.indexOf("youtube-nocookie.com/watch?v=") >= 0 || (url.indexOf("youtube-nocookie.com/embed/") >= 0)) {
                    var id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube-nocookie.com/embed/" + id + "?rel=0&autoplay=1" );

                    $(el).featherlight();
                }
            }
        });

    }

    __onLoad() {
        const me = this;
        console.log("Theme Load");

        this.$hero.css('margin-top', this.navbarHeight + "px");


        const top = 1; // Trigger on any scrolling
        $(document).scroll(function () {
            const scrollPos = $(document).scrollTop();
            if (top && scrollPos >= top) {
                $('.navbar-top').addClass('scrolled');
            } else if (top && scrollPos < top) {
                $('.navbar-top').removeClass('scrolled');
            }
        });
    }

    __onResize() {
        const me = this;

        this.$hero.css('margin-top', this.navbarHeight + "px");
    }


    get utils() {
        return Utils;
    }

    get navbarHeight() {
        return this.$navbar.outerHeight();
    }
}
